module.exports = __webpack_public_path__ + "img/scene-entrance.344d1b5f.jpg";